export enum HeaderModeType {
    DEFAULT = 'default',
    FIRST_ROW = 'first_row',
    MINI = 'mini',
    NONE = 'none',
}
